import { defineComponent as _defineComponent } from 'vue'


interface Props {
	text?: string;
}
interface Emits {
	(e: "click"): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BlueBtn',
  props: {
    text: null
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ({
	(e: "click"): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	text?: string;
}




const handleClick = () => {
	emit("click");
};

return { __sfc: true,props, emit, handleClick }
}

})